import { MoneyLabel } from "../../../general/MoneyLabel.tsx";
import { DEFAULT_CURRENCY } from "../../../../types/constants.ts";

function Triangle({ expanded, className }: { expanded: boolean; className?: string }) {
    return <span className={className}>{expanded ? "▾" : "▸"}</span>;
}

interface YearProps {
    label: string;
    total: number;
    expanded: boolean;
    onToggle: () => void;
}

export function TaxYearHeader({ label, total, expanded, onToggle }: YearProps) {
    return (
        <tr className="cursor-pointer bg-gray-50 hover:bg-gray-100" onClick={onToggle}>
            <td colSpan={3} className="px-4 py-2">
                <div className="flex items-center">
                    <button
                        type="button"
                        onClick={(event) => { event.stopPropagation(); onToggle(); }}
                        aria-expanded={expanded}
                        aria-label={label}
                        className="mr-2 rounded p-1 hover:bg-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--primary)]"
                    >
                        <Triangle expanded={expanded} className="block w-3 text-xs leading-none text-gray-700"/>
                    </button>
                    <span className="text-sm font-semibold text-gray-700">{label}</span>
                </div>
            </td>
            <td className="px-4 py-2 text-right text-sm text-gray-700 tabular-nums whitespace-nowrap [&_*]:font-semibold">
                {!expanded && <MoneyLabel value={total} showCurrency={true} currency={DEFAULT_CURRENCY}/>}
            </td>
        </tr>
    );
}

interface TypeProps {
    label: string;
    total: number;
    expanded: boolean;
    onToggle: () => void;
}

export function TaxTypeHeader({ label, total, expanded, onToggle }: TypeProps) {
    return (
        <tr className="cursor-pointer hover:bg-gray-50" onClick={onToggle}>
            <td colSpan={3} className="pl-8 pr-4 pt-2.5 pb-1">
                <div className="flex items-center">
                    <button
                        type="button"
                        onClick={(event) => { event.stopPropagation(); onToggle(); }}
                        aria-expanded={expanded}
                        aria-label={label}
                        className="mr-1.5 rounded p-0.5 hover:bg-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--primary)]"
                    >
                        <Triangle expanded={expanded} className="block w-3 text-[11px] leading-none text-gray-600"/>
                    </button>
                    <span className="text-[11px] font-bold uppercase tracking-[0.05em] text-gray-600">{label}</span>
                </div>
            </td>
            <td className="px-4 pt-2.5 pb-1 text-right text-sm text-gray-600 tabular-nums whitespace-nowrap [&_*]:font-semibold">
                {!expanded && <MoneyLabel value={total} showCurrency={true} currency={DEFAULT_CURRENCY}/>}
            </td>
        </tr>
    );
}

export function TaxTypeTotalRow({ label, total }: { label: string; total: number }) {
    return (
        <tr>
            <td colSpan={3} className="px-4 py-2 pl-16 text-[11px] font-bold uppercase tracking-[0.05em] text-gray-600">
                {`Totaal ${label}`}
            </td>
            <td className="px-4 py-2 text-right text-sm text-gray-600 tabular-nums whitespace-nowrap [&_*]:font-semibold">
                <MoneyLabel value={total} showCurrency={true} currency={DEFAULT_CURRENCY}/>
            </td>
        </tr>
    );
}

export function TaxYearTotalRow({ year, total }: { year: number; total: number }) {
    return (
        <tr className="border-t-2 border-dashed border-gray-400">
            <td colSpan={3} className="px-4 py-2 pl-8 text-sm font-semibold text-gray-700">
                {`Totaal ${year}`}
            </td>
            <td className="px-4 py-2 text-right text-sm text-gray-700 tabular-nums whitespace-nowrap [&_*]:font-semibold">
                <MoneyLabel value={total} showCurrency={true} currency={DEFAULT_CURRENCY}/>
            </td>
        </tr>
    );
}
